import { useMutation, useQueryClient } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const deletePost = async (postId: string) => {
	const response = await cmsClient.delete(`/social-posts/${postId}/`);
	return response.data;
};

const useDeletePost = () => {
	const queryClient = useQueryClient();

	return useMutation(deletePost, {
		onSettled: () => {
			queryClient.invalidateQueries(["social-posts"]);
		}
	});
};

export default useDeletePost;
